import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Collapse,
  Table,
  Row,
  Button,
  Spinner,
} from "reactstrap";
//service
import {
  deleteAllFunctionLog,
  getReportFunctions,
} from "../../../utils/services/functions";
//redux
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { useLocation } from "react-router-dom";
//components
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import Pagination from "../../../components/Paginationv3";
import WaitExport from "../../../components/WaitExport";
import { createXlsx } from "./createXlsx";
import useDebounce from "../../../utils/hooks/useDebounce";
import SearchFilters from "../../../components/SearchFilters";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";

import moment from "moment";
function ReportFunctions(props) {
  // collapse
  const [isCollapse, setIsCollapse] = useState(false);
  //Pagination
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  //search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  // modal
  const [modalDeleteAll, setModalDeleteAll] = useState(false);
  //state report functions
  const [reportFunctions, setReportFunctions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // export
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);

  const location = useLocation();
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("name");

  const [confirmAllDisabled, setConfirmAllDisabled] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [dynamic_title, setdynamic_title] = useState("");
  const [dynamic_description, setdynamic_description] = useState("");
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [errorOnDeleteAll, setErrorOnDeleteAll] = useState(false);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);

  const columnsFilter = [
    { name: "Participante", value: "name", type: "text" },
    { name: "Email", value: "email", type: "text" },
    { name: "QR Code", value: "function", type: "text" },
    { name: "Data", value: "data", type: "date" },
  ];

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }
  //date format
  const formatDate = (date) => {
    return `${moment(date).format("l")} - ${date.split("T")[1].slice(0, 8)}`;
  };

  async function getAllReportFunctions() {
    setIsLoading(true);
    await getReportFunctions({
      limit: itemsPerPage,
      offset: currentPage > 0 ? currentPage : 1,
      id: location.state.idEvent,
      jwt: props.state.global_user_data.data.token,
      search: treatmentSearch(),
      columnSearch: activeFilter,
    }).then((response) => {
      if (response.functions) {
        setReportFunctions(response.functions);
        setTotalItems(response.total);
      }
      setIsLoading(false);
    });
  }

  async function confirmDeleteAll() {
    const idEvent = location?.state?.idEvent;
    setLoadingDelete(true);
    await deleteAllFunctionLog(idEvent).then((response) => {
      if (response.message === "deleted") {
        setdynamic_title("Sucesso");
        setdynamic_description("Leituras deletadas com sucesso");
        setLoadingDelete(false);
        setErrorOnDeleteAll(false);
        setsuccess_dlg(true);
      } else {
        setdynamic_title("Erro");
        setdynamic_description("Ocorreu um erro ao deletar as Leituras");
        setLoadingDelete(false);
        setErrorOnDeleteAll(true);
        setsuccess_dlg(true);
      }

      getAllReportFunctions();
    });
  }

  useEffect(() => {
    getAllReportFunctions();
  }, [debouncedSearch, currentPage, itemsPerPage]);
  return (
    <div>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Relatório de Leituras"
          onConfirm={confirmDeleteAll}
        />
      )}

      {exportInProgress && (
        <WaitExport
          isOpen={exportInProgress}
          preposicao="do"
          name="Relatório de Funções"
          finishExport={finishExport}
          setFinishExport={setFinishExport}
          setExportInProgress={setExportInProgress}
        />
      )}
      {success_dlg ? (
        <SweetAlert
          success={!errorOnDeleteAll}
          error={errorOnDeleteAll}
          title={dynamic_title}
          onConfirm={() => {
            setsuccess_dlg(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <>
            <p>{dynamic_description}</p>
          </>
        </SweetAlert>
      ) : null}

      <Card>
        <CardBody>
          <CardTitle>Relatório por Participantes</CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type={activeFilter === "data" ? "date" : "text"}
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            {reportFunctions.length > 0 && (
              <div className="mobile-btn-section" style={{ width: "100%" }}>
                <Row className="mobile-btns-top">
                  <form
                    className="app-search"
                    style={{ padding: "0px" }}
                    onSubmit={(e) => e.preventDefault()}
                  >
                    <div className="position-relative">
                      <input
                        type={activeFilter === "data" ? "date" : "text"}
                        value={search}
                        className="form-control"
                        placeholder="Pesquisar..."
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <span className="bx bx-search-alt" />
                    </div>
                  </form>
                </Row>
                <SectionComponent
                  sectionName="Opções"
                  setIsOpen={setIsCollapse}
                  isOpen={isCollapse}
                />
                <Collapse isOpen={isCollapse}>
                  <Row className="mobile-btns-top">
                    <div>Exportar Relatório</div>
                  </Row>
                </Collapse>
              </div>
            )}
            <div className="header-btns-container">
              {reportFunctions.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() => {
                    createXlsx({
                      idEvent: location.state.idEvent,
                      countData: totalItems,
                      setFinishExport,
                      jwt: props.state.global_user_data.data.token,
                    });
                    setExportInProgress(true);
                  }}
                >
                  Exportar Relatório
                </Button>
              )}
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Nome do Participante</th>
                  <th>Email do Participante</th>
                  <th>Nome do QR Code</th>
                  <th>Data e Hora da Execução</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <LoadingSkelentonTable lines={10} cols={4} />
                ) : (
                  reportFunctions.map((func, i) => (
                    <tr key={i}>
                      <td>{func.login.nome}</td>
                      <td>{func.login.email}</td>
                      <td>{func.function.description}</td>
                      <td>{formatDate(func.calledAt)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            reportFunctions?.length > 0 && showDeleteAll
              ? "space-between"
              : "end"
          }`,
        }}
      >
        {reportFunctions?.length > 0 && (
          <ActionButtonRounded
            onClick={() => setModalDeleteAll(true)}
            title="Limpar Todas Leituras"
            action="D"
            color="danger"
            setShow={setShowDeleteAll}
            verifyShow={true}
            className="btn-rounded waves-effect waves-light events-button-add-lg"
          />
        )}
        <Pagination
          data={reportFunctions}
          search={search}
          currentIndex={currentPage}
          setCurrentIndex={setCurrentPage}
          countData={totalItems}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(ReportFunctions);
